import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResponseStatus } from 'app/modules/common/enums/common-enums';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { FileService } from 'app/modules/common/services/file.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import moment from 'moment';
import { TipoDocEmpresa } from '../../models/Documentacion/TipoDocEmpresa';
import { DocumentacionService } from '../../../services/documentacion.service';
import { FileFormatEnum } from 'app/modules/common/enums/file-format-enum';

@Component({
    selector: 'app-document-popup',
    templateUrl: './document-popup.component.html',
    styleUrls: ['./document-popup.component.scss'],
    standalone: false
})
export class DocumentPopupComponent implements OnInit {
  
  selectedEmpresaId;
  tipoDocEmpresaList: TipoDocEmpresa[] = [];
  empresaDocumentationFormGroup: UntypedFormGroup;
  file: any;
  fileBase64Value: string;
  public documentTypes: Array<{ value: string, viewValue: string }>;
  //private allowableFileTypes: Array<string> = ['PDF', 'DOC', 'JPG', 'PNG', 'BMP', 'TIF'];
  isInvalidDocumentType = false;
  IsLoading: boolean = false;

  public FileFormatEnum = FileFormatEnum;

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<DocumentPopupComponent>,
  private sharedService: SharedService,
  private _documentacionService: DocumentacionService,
  public fb: UntypedFormBuilder,
  private fileService: FileService) { 
    this.selectedEmpresaId = data;
    this.loadTipoDocEmpresaDropdownList();
  }
  
  ngOnInit(): void 
  {
    this.empresaDocumentationFormGroup = this.fb.group({
      Tipo:['',Validators.required],
      Fecha: ['',Validators.required],
      Descripcion: [],
      Documento: ['', Validators.required],
      TipoDocumento: ['',Validators.required]
    });
    this.empresaDocumentationFormGroup.get('Fecha').setValue(moment());
  }


  loadTipoDocEmpresaDropdownList(): void {
    this._documentacionService.GetTipoDocEmpresaList().subscribe(res => {
      if (res) {
        this.tipoDocEmpresaList = res.result;
      }
    });
  }

  addDocument(buttonReference: any){
    this.IsLoading=true;
    if (this.empresaDocumentationFormGroup.invalid) {
      this.showInvalidFormControls(this.empresaDocumentationFormGroup);
      if(!this.empresaDocumentationFormGroup.controls.Documento.invalid && this.empresaDocumentationFormGroup.controls.TipoDocumento.invalid){
        this.isInvalidDocumentType = true;
      }
      return;
    }
      const fileType = this.empresaDocumentationFormGroup.get('TipoDocumento').value;
    if (!FileFormatEnum.CitationControllerTS.includes(fileType)) {
          return;
    }
    let model = this.empresaDocumentationFormGroup.value;
    const dateString = (model.Fecha !== null) ? DateHelper.getUTCDateString(DateHelper.getNativeDate(model.Fecha)) : null;
    model.DocumentInString = this.fileBase64Value;
    model.EmpresaId = this.selectedEmpresaId
    buttonReference.disabled = true;
    this._documentacionService.AddEmpresaDocument(model)
    .subscribe(res => {
      if(res.result && res.code === ResponseStatus.Success) {
        this.IsLoading=false;
        this.sharedService.ShowSnackBar('¡Guardado correctamente!', 'Okay', 2000);
        buttonReference.enabled = true;
        this.dialogRef.close();
      }else{
        this.IsLoading=false;
        buttonReference.enabled = true;
        this.sharedService.ShowSnackBar('¡Se ha producido un error al guardar!');
      }
    }, err => {
      this.IsLoading=false;
      console.error(err);
      buttonReference.enabled = true;
      this.sharedService.ShowSnackBar('¡Se ha producido un error al guardar!');
    })    
  }

  
  uploadFile(event) {
    this.file = event[0].name;
    this.readFile(event[0]);
  }

  private readFile(file) {
    let currentContext = this;
    let fileReader = new FileReader();
    fileReader.onload = function (event) {
      currentContext.file = file.name;
      currentContext.fileBase64Value = currentContext.fileService.arrayBufferToBase64(fileReader.result);
      currentContext.empresaDocumentationFormGroup.get('TipoDocumento').patchValue(currentContext.fileService.getFileExtention(file.type));
    }
    //if (currentContext.allowableFileTypes.includes(currentContext.fileService.getFileExtention(file.type))) {
      if (FileFormatEnum.EmpresaControllerTS.includes(currentContext.fileService.getFileExtention(file.type))) {
      fileReader.readAsArrayBuffer(file);
      this.empresaDocumentationFormGroup.get('Documento').markAsTouched();
    }
    else {
      this.sharedService.ShowSnackBar('Este tipo de document no se puede adjuntar', 'Okay', 4000);
    }
  }
  
  showInvalidFormControls(formGroup: UntypedFormGroup) {
    if (formGroup !== undefined) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            control.markAsDirty({ onlySelf: true });
            control.markAsTouched({ onlySelf: true });
        });
    }
  }

  onclickFileInput(obj: any){
    obj.click();
    this.isInvalidDocumentType = false;

  }
  cancel(){
    this.dialogRef.close();
  }
}
